module.exports = __webpack_public_path__ + "static/img/PC-2.104fcf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcyixuekao/PC-2.png
// module id = lcIN
// module chunks = 0